import STATES from './US_STATES';
import { logError, localStore } from 'utils';

export const STORAGE_KEYS = {
  REFRESH_TOKEN: 'rr_refresh_token',
  POST_REFRESH_TOKEN_GENERATE_RELOAD: 'rr_post_refresh_token_generate_reload',
  LOGGED_IN_STORE_NAME: 'rrloggedInStoreName',
  LOGGED_IN_STORE_GUID: 'rrloggedInStoreGuId',
  LOGGED_IN_STORE_ID: 'rrloggedInStoreId',
  USER_DATA: 'userData',
  USER_ACCESS: 'userAccess',
  PASSWORD_CHANGE_REQUIRED: 'passwordChangeRequired',
  TEMP_RETEX_APPROVAL: 'tempRetexApproval',
  ANALYTICS_DATE_RANGE_KEY: 'tr-home-date-range',
  WAREHOUSE_FILTERS: 'rr-warehouse-filters'
};

const loggedKeyErrorList = [];

function logKeyError(key) {
  try {
    if (loggedKeyErrorList.indexOf(key) === -1) {
      logError(new Error(`Key not found in master data - ${key}`));
      loggedKeyErrorList.push(key);
    }
  } catch (e) {
    logError(e);
  }
}

function findValue(arr, obj) {
  try {
    if (arr.length === 1) {
      if (arr[0] === 'null') {
        return '-';
      }
      return obj[arr[0]];
    }
    var key = arr.splice(0, 1)[0];
    return findValue(arr, obj[key]);
  } catch (e) {
    return 'undefined';
  }
}

const DICTIONARY = () => {
  const obj = JSON.parse(localStore.get('dictionary')) || {};
  return obj;
};

const find = (group, key) => {
  try {
    const STORE = DICTIONARY()[group];
    if (STORE[key]) {
      return STORE[key];
    } else {
      logKeyError(key);
      return key;
    }
  } catch (e) {
    logError(e);
    return key;
  }
};

const Shipping_Method = key => find('retailerShippingMethodChoices', key);

const Refund_Method = key => find('retailerPaymentMethodChoices', key);

const findEcommPlatform = key => find('ecommerce_platforms', key);

const findCurrency = key => {
  if (!key) return null;
  return find('currencySymbolChoices', key);
};

/**
 * @returns {Record<import("utils/types").EcommPlatformSource, string>}
 */
const getEcomPlatformMap = () => {
  return DICTIONARY()['ecommerce_platforms'] || {};
};

const getRefundMethodChoices = () => {
  return DICTIONARY()['retailerPaymentMethodChoices'] || {};
};

const getRefundMethodSlugs = () => {
  return DICTIONARY()['retailer_payment_method_slug'] || {};
};

const activeServiceRequestChoices = () => {
  return DICTIONARY()['inprogress_request_status'] || [];
};

const rejectedServiceRequestChoices = () => {
  return DICTIONARY()['rejected_service_request_status'] || [];
};

const approvedServiceRequestChoices = () => {
  return DICTIONARY()['successful_request_status'] || [];
};

const pickupSlotChoices = () => {
  return DICTIONARY()['pickup_slot_choices'] || [];
};

const orderServiceStatuses = () => {
  return DICTIONARY()['order_service_statuses'] || [];
};

const orderServiceTerminalStatuses = () => {
  return DICTIONARY()['terminal_order_service_statuses'] || [];
};

const orderServiceInprogressStatuses = () => {
  return DICTIONARY()['inprogress_order_service_statuses'] || [];
};

const RestockChoices = key => {
  return find('dispositionMethodChoices', key);
};

// Alias to a more general name
const paymentMethod = Refund_Method;

const Ret_Exc_Status = key => find('retexStatusChoices', key);

const deliveryStatusChoices = key => find('deliveryStatusChoices', key);

const entityTypeChoices = key => find('entityTypeChoices', key);

const financialStatus = key => find('order_financial_statuses', key);

const pickupSlotChoice = key => {
  return find('pickup_slot_choices', key);
};

const paymentWaiveOffHelpText = () => find('paymentWaiveOff', 'infoText');

const tagRuleTypes = key => find('tag_rule_types', key);

const tagRuleActions = key => find('tag_rule_actions', key);

const UNITS = {
  dimension: [
    { value: 'in', label: 'in' },
    { value: 'cm', label: 'cm' },
    { value: 'm', label: 'm' }
  ],
  weight: [
    { value: 'g', label: 'gm' },
    { value: 'kg', label: 'kg' },
    { value: 'oz', label: 'oz' },
    { value: 'lb', label: 'lb' }
  ]
};

function index(key) {
  const keyArray = key.split('.');
  const obj = JSON.parse(localStore.get('dictionary'));
  var value = findValue(keyArray, obj);
  if (typeof value === 'undefined' || value === 'undefined' || value === null) {
    logKeyError(key);
    value = keyArray[keyArray.length - 1];
  }
  return value;
}

function findAllValues(key) {
  const obj = JSON.parse(localStore.get('dictionary'));
  return obj[key];
}

/**
 * Name of the store the browser is currently signed in to, or null when there
 * is no active session.
 * @returns {string|null}
 */
const getActiveSessionStoreName = () =>
  localStore.get(STORAGE_KEYS.LOGGED_IN_STORE_NAME) || null;

export {
  Shipping_Method,
  Refund_Method,
  Ret_Exc_Status,
  STATES,
  paymentMethod,
  findEcommPlatform,
  getEcomPlatformMap,
  getRefundMethodChoices,
  getRefundMethodSlugs,
  deliveryStatusChoices,
  entityTypeChoices,
  pickupSlotChoices,
  financialStatus,
  pickupSlotChoice,
  orderServiceStatuses,
  orderServiceTerminalStatuses,
  orderServiceInprogressStatuses,
  activeServiceRequestChoices,
  rejectedServiceRequestChoices,
  approvedServiceRequestChoices,
  findAllValues,
  getActiveSessionStoreName,
  RestockChoices,
  findCurrency,
  paymentWaiveOffHelpText,
  UNITS,
  tagRuleTypes,
  tagRuleActions
};

export default index;
